import { gql } from 'graphql-request';

const Footer = gql`
  fragment Footer on Footer {
    city
    email
    postCode
    telephone
    twitterUrl
    streetName
    facebookUrl
    houseNumber
    instagramUrl
    tiktokUrl
    linkedinUrl
    publicLegalPages {
      page: pageSpecific {
        id
        url
        title
      }
    }
  }
`;
export default Footer;
